import isTextEdited from './is-text-edited';
import doesElementHaveDefaultSrc from './does-element-have-default-src';

export default {
  isTextEdited,
  doesElementHaveDefaultSrc,
};
